import IBagReferences, { BagReferences } from '@/models/bag-references';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import * as THREE from 'three'
import { Mesh, SkinnedMesh } from 'three';
import tackSettings from '@/settings/tack-settings.json'
import frontSettings from '@/settings/front-settings.json'
import SentrySingleton from '@/singletons/sentry-singleton';

export default class BagFinderService {

    find(gltf: GLTF): IBagReferences {
        const bag = gltf.scene
        return new BagReferences({
            gltf: gltf,
            bag: bag,
            parent: new THREE.Group(),
            metal: this.findObject(bag, '02_Metal') as SkinnedMesh,
            transparent: this.findObject(bag, '02_transparaent') as SkinnedMesh,
            body: this.findObject(bag, '01_Landcell') as SkinnedMesh,
            edge: this.findObject(bag, '01_Edge') as SkinnedMesh,
            pocket: this.findObject(bag, '03_Pocket') as Mesh,
            side: this.findObject(bag, '03_Side') as Mesh,
            fronts: this.findMeshes(bag, frontSettings.allMeshes),
            ribbon: this.findObject(bag, '05_Ribbon') as Mesh,
            covertacks: this.findMeshes(bag, tackSettings.options.map(item => item.value)),
            back: this.findObject(bag, '03_Back') as SkinnedMesh,
        })
    }

    private findObject(bag: THREE.Group, name: string): THREE.Object3D | null {
        try {
            let obj = bag.getObjectByName(name)
            if (obj == null || obj == undefined) {
                console.error("Cannot find group in bag by name: " + name)
                return null
            }
            return obj!
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return null
        }
    }

    private findMeshes(bag: THREE.Group, meshNames: any[]): THREE.SkinnedMesh[] {
        try {
            let meshes = [] as THREE.SkinnedMesh[]
            meshNames.forEach(meshName => {
                const obj = this.findObject(bag, meshName) as SkinnedMesh
                meshes.push(obj)
            })
            return meshes
        }
        catch (err) {
            SentrySingleton.instance.captureException(err)
            return []
        }
    }
}